import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, saveSession } from "@/lib/api";
import { toast } from "sonner";

/**
 * Pantalla de activación de cuenta tras pagar la consultoría siendo un email nuevo.
 * URL: /consulting/activate/:token
 * El usuario elige contraseña y queda logueado directamente.
 */
export default function ConsultingActivate() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("La contraseña debe tener al menos 8 caracteres");
      return;
    }
    if (password !== confirm) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    setLoading(true);
    try {
      const r = await api.post("/consulting/activate", { token, password });
      saveSession(r.data.access_token, { email: r.data.email, is_admin: false });
      toast.success("Cuenta activada");
      // iter91 · redirección inteligente según los productos del usuario.
      const products = Array.isArray(r.data.products) ? r.data.products : [];
      if (products.includes("consulting")) {
        navigate("/consulting");
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      const detail = err?.response?.data?.detail || "No se pudo activar la cuenta";
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6 py-16">
      <div className="max-w-md w-full rounded-2xl bg-white border-2 shadow-xl p-10" style={{ borderColor: "#C9A84C" }}>
        <h1 className="font-display text-2xl font-bold text-slate-900 mb-2">Establece tu contraseña</h1>
        <p className="text-sm text-slate-600 mb-6">
          Elige una contraseña segura para acceder a tu área privada de OptimizaRRHH.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <input
            type="password"
            placeholder="Contraseña (mín. 8 caracteres)"
            className="w-full rounded-lg border border-slate-300 px-4 py-3 text-sm focus:border-emerald-600 focus:outline-none"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="activate-password-input"
          />
          <input
            type="password"
            placeholder="Repite la contraseña"
            className="w-full rounded-lg border border-slate-300 px-4 py-3 text-sm focus:border-emerald-600 focus:outline-none"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            data-testid="activate-confirm-input"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-full py-3 font-bold shadow disabled:opacity-50"
            style={{ background: "#0F6E56", color: "#C9A84C" }}
            data-testid="activate-submit-btn"
          >
            {loading ? "Activando…" : "Activar cuenta y entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
